import {
  Info as Icon // TODO: select an icon
} from 'components/icons';

export const meta = {
  id: 'Scopes',
  title: 'Scopes',
  category: 'Scopes',
  unique: true,
  icon: Icon,
  version: '1.0.0',
  description: `The module to manage the current org, product and tenant the user is currently working on`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 680,
    height: 320
  }
};
